export default {
  title: {
    id: 'bo_seller.insights.financial_report.title',
    defaultMessage: 'Your financial report',
  },
  subtitle: {
    id: 'bo_seller.insights.financial_report.subtitle',
    defaultMessage:
      'Keep track of every cent you make and spend with this in-depth analysis of your sales and fees.',
  },
  loading: {
    id: 'bo_seller.insights.financial_report.loading',
    defaultMessage: 'Loading your financial report',
  },
  percentage: {
    id: 'bo_seller.insights.financial_report.percentage',
    defaultMessage: '{percentage}%',
  },
  yearToDate: {
    id: 'bo_seller.insights.financial_report.year_to_date',
    defaultMessage: '{year} YTD',
  },
}
